import React, { useEffect } from "react";

export default function Error404() {
  useEffect(() => {
    window.location.href = "/";
  }, []);

  return <div>{/* <p>Error 404</p> */}</div>;
}
